import { render, staticRenderFns } from "./exchange-outline.component.vue?vue&type=template&id=db59d33e"
import script from "./exchange-outline.component.vue?vue&type=script&lang=js"
export * from "./exchange-outline.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports